import { Counter } from "../Counter";
import { SectionEyebrow } from "../SectionEyebrow";

const STAT_ITEMS = [
    { id: "anos", v: (s) => s.anos_trayectoria, suffix: "", label: "Años de trayectoria" },
    { id: "vidas", v: (s) => s.vidas_impactadas, suffix: "+", label: "Vidas impactadas" },
    { id: "voluntarios", v: (s) => s.voluntarios_activos, suffix: "+", label: "Voluntarios activos" },
    { id: "proyectos", v: (s) => s.proyectos_realizados, suffix: "", label: "Proyectos realizados" },
    { id: "comunidades", v: (s) => s.comunidades_atendidas, suffix: "", label: "Comunidades atendidas" },
];

export const ImpactStats = ({ stats }) => (
    <section className="py-20 lg:py-28 bg-white" data-testid="impact-stats-section">
        <div className="container-fe">
            <div className="max-w-2xl">
                <SectionEyebrow>Nuestro impacto</SectionEyebrow>
                <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-brand-navy leading-tight">
                    Cifras que cuentan historias reales.
                </h2>
            </div>
            <div className="mt-14 grid grid-cols-2 lg:grid-cols-5 gap-6">
                {STAT_ITEMS.map((it) => (
                    <div
                        key={it.id}
                        className="rounded-2xl border border-black/5 bg-brand-cream p-7 hover:bg-white hover:border-brand-green/30 transition-all"
                    >
                        <div className="font-display text-4xl lg:text-5xl font-bold text-brand-green">
                            <Counter to={it.v(stats)} suffix={it.suffix} />
                        </div>
                        <div className="mt-2 text-sm text-brand-navy font-medium">{it.label}</div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);
